import { render } from "./index.vue?vue&type=template&id=f94582e0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f94582e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\26494\\Documents\\GitHub\\GitHub\\doge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f94582e0"]])

export default __exports__